import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import {
  Typography,
} from '@mui/material';
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import bgFront from "assets/images/cloud1.jpg";
import bgBack from "assets/images/cloud2.jpg";
import logo from "assets/images/labasservice1.png";

function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                title={
                  <>
                    LabAsService
                  </>
                }
                description="Pre-configured lab servers on the cloud which can be accessed from any machine with an Internet connection"
              />
              <RotatingCardBack
                image={bgBack}
                title="Discover More"
                description="LabAsService has an easy-to-use UI and dashboard to Manage the lab servers. Can schedule the powering on/off of lab servers on specific day and time. No hidden charges, no suspicious plans, no conspiracy theories, Just pay per Usage."
                action={{
                  type: "internal",
                  route: "https://www.zippyops.com/labasservice",
                  label: "Know More",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <DefaultInfoCard
                  color="info"
                  icon={<img src={logo} alt="Logo" style={{ width: '300px', height: '90px' }} />}
                  description="Labs are a very important ingredient for successful training. Hands-on experience is required to translate knowledge into real-world results.Well Performing ready to use labs is very important to keep the participants engaged. Trainers and training organizations spend lots of effort in setting up the labs or the training hours are wasted in troubleshooting lab environments."
                  direction="left"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
